import React from "react";
import {
  Button,
  Row,
  Col,
  CardBody,
  Collapse,
  Card,
  Input,
  Label,
  Table
} from "reactstrap";

// Constants
import {
  cobrowseTypes,
  listOfAvailableSubModule 
} from "UTILS/Constants";

// Images
import ic_arrow_down from "ASSETS/Images/ic_arrow_down.svg";
import ic_edit from "ASSETS/Images/qr_icons/ic_edit.webp";
import ic_add from "ASSETS/Images/ic_add_storage.svg";
import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

import { getMessage } from "CONFIG/i18n";
import { checkEmpty } from "UTILS/Utility";
import "./SettingsPage.less"

class InboundCobrowseSettingsSection extends React.Component { 

  constructor(props) {
    super(props);
    this.state = {
      newValue: '',
      enableEdit: false,
      itemToEdit: '',
      itemEdit: '',
      indexToEdit: null,
      // Universal Links state
      newUniversalLink: '',
      enableUniversalLinkEdit: false,
      universalLinkToEdit: '',
      universalLinkEdit: '',
      universalLinkIndexToEdit: null,
    };
  }

  handleInputChange = (event) => {    
    const newTxt = event.target.value;
    // accept dot, uppercase, lowercase, numbers and dash only
    // DEFC0292976: add curly bracket, asterisk, spaces and colon in regex
    if (/^[a-zA-Z0-9.#{}\[\]:'",* _-]*$/.test(newTxt))  {
      if (this.state.enableEdit) {
        this.setState({
          itemToEdit: newTxt
        })
      } 
      else {
        this.setState({ newValue: newTxt });
      }
    }
  };

  handleUniversalLinkInputChange = (event) => {
    const newTxt = event.target.value;
    // Allow typing characters - validate only valid URL characters and partial https://
    if (/^[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=\-]*$/.test(newTxt) || newTxt === '') {
      if (this.state.enableUniversalLinkEdit) {
        this.setState({
          universalLinkToEdit: newTxt
        })
      } 
      else {
        this.setState({ newUniversalLink: newTxt });
      }
    }
  };

  handleSetTextInputChange = (event) => {
    const newTxt = event.target.value;
    const fieldName = event.target.name;
    
    // Allow any text for Set Text functionality
    if (this.state.enableSetTextEdit) {
      if (fieldName === 'setTextToEdit') {
        this.setState({
          setTextToEdit: newTxt
        });
      } else if (fieldName === 'setTextValueToEdit') {
        this.setState({
          setTextValueToEdit: newTxt
        });
      } else if (fieldName === 'setTextLanguageToEdit') {
        this.setState({
          setTextLanguageToEdit: newTxt
        });
      }
    } 
    else {
      if (fieldName === 'newSetText') {
        this.setState({ newSetText: newTxt });
      } else if (fieldName === 'newSetTextValue') {
        this.setState({ newSetTextValue: newTxt });
      } else if (fieldName === 'newSetTextLanguage') {
        this.setState({ newSetTextLanguage: newTxt });
      }
    }
  };

handlePaste = (event) => {
  event.preventDefault(); 
  const pastedText = event.clipboardData.getData('text');
  
  // accept dot, uppercase, lowercase, numbers and dash only
  // DEFC0292976: add curly bracket, asterisk, spaces and colon in regex
  if (/^[a-zA-Z0-9.#{}\[\]:'",* _-]*$/.test(pastedText))  {
    if (this.state.enableEdit) {
      this.setState({
        itemToEdit: pastedText
      });
    } else {
      this.setState({ newValue: pastedText });
    }
  }
};

handleUniversalLinkPaste = (event) => {
  event.preventDefault();
  const pastedText = event.clipboardData.getData('text');
  
  // Allow pasting URL characters - same validation as typing
  if (/^[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=\-]*$/.test(pastedText)) {
    if (this.state.enableUniversalLinkEdit) {
      this.setState({
        universalLinkToEdit: pastedText
      });
    } else {
      this.setState({ newUniversalLink: pastedText });
    }
  }
};

handleSetTextPaste = (event) => {
  event.preventDefault();
  const pastedText = event.clipboardData.getData('text');
  const fieldName = event.target.name;
  
  // Allow any text for Set Text functionality
  if (this.state.enableSetTextEdit) {
    if (fieldName === 'setTextToEdit') {
      this.setState({
        setTextToEdit: pastedText
      });
    } else if (fieldName === 'setTextValueToEdit') {
      this.setState({
        setTextValueToEdit: pastedText
      });
    }
  } else {
    if (fieldName === 'newSetText') {
      this.setState({ newSetText: pastedText });
    } else if (fieldName === 'newSetTextValue') {
      this.setState({ newSetTextValue: pastedText });
    }
  }
};

  handleAddItem = () => {
    this.props.addCssItem(this.state.newValue);
    this.setState({ newValue: '' });
    this.toggleVisibility();
  };

  handleEditItem = () => {
    this.props.editCssItem(this.state.indexToEdit,this.state.itemToEdit);
    this.setState({ newValue: '' });
    this.toggleVisibility();
  }

  toggleVisibility = () => {
    const newIsShown = !this.props.showCSSelectorAdd;
    this.props.onToggle(newIsShown);
    this.setState({
      enableEdit: false,
      itemToEdit: '',
      itemEdit: '',
    });
  };

  toggleItemEdit = (index) => {
    this.toggleVisibility();
    this.setState({ 
      enableEdit: true,
      indexToEdit: index,
      itemToEdit: this.props.selectors[index].selector,
      itemEdit: this.props.selectors[index].selector,
    });
  }

  // Universal Links methods
  handleAddUniversalLink = () => {
    this.props.addUniversalLink(this.state.newUniversalLink);
    this.setState({ newUniversalLink: '' });
    this.toggleUniversalLinksVisibility();
  };

  handleEditUniversalLink = () => {
    this.props.editUniversalLink(this.state.universalLinkIndexToEdit, this.state.universalLinkToEdit);
    this.setState({ newUniversalLink: '' });
    this.toggleUniversalLinksVisibility();
  }

  toggleUniversalLinksVisibility = () => {
    const newIsShown = !this.props.showUniversalLinkAdd;
    this.props.onToggleUniversalLinks(newIsShown);
    this.setState({
      enableUniversalLinkEdit: false,
      universalLinkToEdit: '',
      universalLinkEdit: '',
    });
  };

  toggleUniversalLinkEdit = (index) => {
    this.toggleUniversalLinksVisibility();
    this.setState({ 
      enableUniversalLinkEdit: true,
      universalLinkIndexToEdit: index,
      universalLinkToEdit: this.props.universalLinks[index],
      universalLinkEdit: this.props.universalLinks[index],
    });
  }

  render() {
  
    return (
      <div className="section">
        <Row className="noMargin">
          <Col md={10} className="mainTitle">
            {getMessage("INBOUND_CO_BROWSE")}
          </Col>
          <Col>
            <img
              style={{ transform: `rotate(${this.props.inboundCobrowseRotation}deg)` }}
              className="dropDown cursorPointer floatRight"
              src={ic_arrow_down}
              onClick={() => this.props.handleInboundCobrowseArrowClick()} />
          </Col> 
        </Row>
        <Collapse isOpen={this.props.isInboudCobrowseToggler}>
          <Card className="borderlessCard">
            {/* CSS Selector Section */}
            <CardBody className="topCardBody">
              <Row className="rowPadding">
                <Col xs={2} className="colInboundCobrowse">
                  <Switch
                    switchOn={this.props.inbIsMaskingEnabled}
                    toggleSwitch={(event)=>{this.props.toggleInboundMaskingSwitch(event)}}
                  />
                </Col>
                <Col xs={8} className="textOverflow">
                  {getMessage("ENABLE_INBOUND_COBROWSE_MASKING")}
                </Col>
                <Col xs={2} className="colInboundCobrowseRight">
                  <img src={ic_add}
                    onClick={this.toggleVisibility}
                    title={getMessage("ADD") + "/" + getMessage("EDIT") + String.fromCharCode(160) + getMessage("CSS_SELECTOR")}
                  />
                </Col>
              </Row>
              
              <Row className="rowPadding">
                <Table className="tableInboundCoBrowse">
                  <thead>
                    <tr>
                      <th className="num">{getMessage("SERIAL_NUMBER")}</th>
                      <th className="main">{getMessage("CSS_SELECTOR")}</th>
                      <th></th> 
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.selectors.map((item,index) =>              
                      <tr key={item.selector + index}>
                        <td>{index + 1}</td>
                        <td>{item.selector}</td>
                        <td>
                          <img src={ic_edit} alt="Edit" className="cursorPointer px-2"
                            onClick={() => {this.toggleItemEdit(index)}}
                          />
                          <img
                            src={ic_delete} alt="Delete" className="cursorPointer px-2"
                            onClick={() => this.props.handleDeleteSelector(index)}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>

              {/* CSS Selector Add/Edit*/}
              {this.props.showCSSelectorAdd && 
            <div className="cobrowseCard inboundCobrowseCard mt-3">
              <Row className="rowPadding">
                <Col className="colInboundCobrowse">
                  {this.state.enableEdit ? (
                    getMessage("CSS_SELECTOR") + String.fromCharCode(160) + "(" + getMessage("EDIT") + "): " + this.state.itemEdit
                  ) : (
                    getMessage("CSS_SELECTOR") + String.fromCharCode(160) + "(" + getMessage("ADD") + ")"
                  )}
                </Col>
                <Col>
                  <Button close aria-label="Cancel" onClick={this.toggleVisibility} type="button"/>
                </Col>
              </Row>
      
              <Row className="rowPadding">
                <Col xs={3} className="colInboundCobrowse">{getMessage("CSS_SELECTOR")} :</Col>
                <Col xs={9}>
                  <Input
                    type="text"
                    name={this.state.enableEdit ? "itemToEdit" : "newValue"}
                    className="inputFormControl"
                    onChange={this.handleInputChange}
                    onPaste={this.handlePaste}
                    value={this.state.enableEdit ? (this.state.itemToEdit) : (this.state.newValue)}
                  />  
                </Col> 
              </Row>
              <Row className="interCardContent floatRight mx-2">
                <Button
                  className={
                    (this.state.enableEdit 
                      ? (!this.state.itemToEdit.trim() || this.state.itemToEdit === this.props.selectors[this.state.indexToEdit]?.selector)
                      : !this.state.newValue.trim())
                      ? "disabledBtn ml-3 mt-2"
                      : "borderBtn cursorPointer bgwhite ml-3 mt-2"
                  }
                  disabled={
                    this.state.enableEdit 
                      ? (!this.state.itemToEdit.trim() || this.state.itemToEdit === this.props.selectors[this.state.indexToEdit]?.selector)
                      : !this.state.newValue.trim()
                  }
                  style={
                    (this.state.enableEdit 
                      ? (!this.state.itemToEdit.trim() || this.state.itemToEdit === this.props.selectors[this.state.indexToEdit]?.selector)
                      : !this.state.newValue.trim())
                      ? { cursor: 'no-drop', pointerEvents: 'auto' }
                      : { cursor: 'pointer' }
                  }
                  onClick={this.state.enableEdit ? this.handleEditItem : this.handleAddItem}
                >
                  {this.state.enableEdit ? (getMessage("EDIT")) : (getMessage("ADD"))}
                </Button>
              </Row>
            </div>
              }
            </CardBody>

            {/* Universal Links Section */}
            <CardBody className="bottomCardBody">
              <Row className="rowPadding">
                <Col xs={2} className="colInboundCobrowse">
                  <Switch
                    switchOn={this.props.universalLinksEnabled}
                    toggleSwitch={(event)=>{this.props.toggleUniversalLinksSwitch(event)}}
                  />
                </Col>
                <Col xs={8} className="textOverflow">
                  {getMessage("ENABLE_UNIVERSAL_LINKS")}
                </Col>
                <Col xs={2} className="colInboundCobrowseRight">
                  <img src={ic_add}
                    onClick={this.toggleUniversalLinksVisibility}
                    title={getMessage("ADD") + "/" + getMessage("EDIT") + String.fromCharCode(160) + getMessage("UNIVERSAL_LINKS")}
                  />
                </Col>
              </Row>
            
              <Row className="rowPadding">
                <Table className="tableInboundCoBrowse">
                  <thead>
                    <tr>
                      <th className="num">{getMessage("SERIAL_NUMBER")}</th>
                      <th className="main">{getMessage("UNIVERSAL_LINKS")}</th>
                      <th></th> 
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.universalLinks && this.props.universalLinks.map((link, index) =>              
                      <tr key={link + index}>
                        <td>{index + 1}</td>
                        <td>{link}</td>
                        <td>
                          <img src={ic_edit} alt="Edit" className="cursorPointer px-2"
                            onClick={() => {this.toggleUniversalLinkEdit(index)}}
                          />
                          <img
                            src={ic_delete} alt="Delete" className="cursorPointer px-2"
                            onClick={() => this.props.handleDeleteUniversalLink(index)}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>

              {/* Universal Links Add/Edit Form - No Card wrapper */}
              {this.props.showUniversalLinkAdd && 
            <div className="cobrowseCard inboundCobrowseCard mt-3">
              <Row className="rowPadding">
                <Col className="colInboundCobrowse">
                  {this.state.enableUniversalLinkEdit ? (
                    getMessage("UNIVERSAL_LINKS") + String.fromCharCode(160) + "(" + getMessage("EDIT") + "): " + this.state.universalLinkEdit
                  ) : (
                    getMessage("UNIVERSAL_LINKS") + String.fromCharCode(160) + "(" + getMessage("ADD") + ")"
                  )}
                </Col>
                <Col>
                  <Button close aria-label="Cancel" onClick={this.toggleUniversalLinksVisibility} type="button"/>
                </Col>
              </Row>
        
              <Row className="rowPadding">
                <Col xs={3} className="colInboundCobrowse">{getMessage("UNIVERSAL_LINKS_LABEL")} :</Col>
                <Col xs={9}>
                  <Input
                    type="text"
                    name={this.state.enableUniversalLinkEdit ? "universalLinkToEdit" : "newUniversalLink"}
                    className="inputFormControl"
                    onChange={this.handleUniversalLinkInputChange}
                    onPaste={this.handleUniversalLinkPaste}
                    value={this.state.enableUniversalLinkEdit ? (this.state.universalLinkToEdit) : (this.state.newUniversalLink)}
                  />  
                </Col> 
              </Row>
              <Row className="interCardContent floatRight mx-2">
                <Button
                  className={
                    (this.state.enableUniversalLinkEdit 
                      ? (!this.state.universalLinkToEdit.trim() || this.state.universalLinkToEdit === this.props.universalLinks[this.state.universalLinkIndexToEdit])
                      : !this.state.newUniversalLink.trim())
                      ? "disabledBtn ml-3 mt-2"
                      : "borderBtn cursorPointer bgwhite ml-3 mt-2"
                  }
                  disabled={
                    this.state.enableUniversalLinkEdit 
                      ? (!this.state.universalLinkToEdit.trim() || this.state.universalLinkToEdit === this.props.universalLinks[this.state.universalLinkIndexToEdit])
                      : !this.state.newUniversalLink.trim()
                  }
                  style={
                    (this.state.enableUniversalLinkEdit 
                      ? (!this.state.universalLinkToEdit.trim() || this.state.universalLinkToEdit === this.props.universalLinks[this.state.universalLinkIndexToEdit])
                      : !this.state.newUniversalLink.trim())
                      ? { cursor: 'no-drop', pointerEvents: 'auto' }
                      : { cursor: 'pointer' }
                  }
                  onClick={this.state.enableUniversalLinkEdit ? this.handleEditUniversalLink : this.handleAddUniversalLink}
                >
                  {this.state.enableUniversalLinkEdit ? (getMessage("EDIT")) : (getMessage("ADD"))}
                </Button>
              </Row>
            </div>
              }
            </CardBody>
          </Card>
        </Collapse>
      </div>
    )
  }
}
export default InboundCobrowseSettingsSection;
